var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomePageImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 672.861,
    height: 410.678,
    viewBox: "0 0 672.861 410.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13103",
    "data-name": "Group 13103",
    transform: "translate(-51.569 -394.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(2.458 60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M703.44,449a24.99,24.99,0,0,0-.51-3.15A12.86,12.86,0,0,0,686.08,437a11.9,11.9,0,0,0-3.22,1.75,11.772,11.772,0,0,0-2.7,2.71,12.73,12.73,0,0,0,0,15.07,12.8,12.8,0,0,0,12.63,5.02,12.631,12.631,0,0,0,5.4-2.37,13,13,0,0,0,4.74-7,24.644,24.644,0,0,0,.51-3.15,10.121,10.121,0,0,1-.07,1.84,8.9,8.9,0,0,1-.24,1.36,13.147,13.147,0,0,1-17.26,9.22,12.53,12.53,0,0,1-3.36-1.79,12.279,12.279,0,0,1-2.81-2.81,13.2,13.2,0,0,1,0-15.68,13.23,13.23,0,0,1,13.17-5.14,13.1,13.1,0,0,1,10.26,9.78,9.113,9.113,0,0,1,.24,1.36,6.85,6.85,0,0,1,.08,1,6.516,6.516,0,0,1-.01.83Z",
    transform: "translate(4.972 257.544)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    transform: "translate(690.702 701.808)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M77.31,363.61c-1-1.5-2.24-2.06-3.69-3.1a7.64,7.64,0,0,1-3.32-4c-.44-1.73.64-3.91,2.42-4s2.93,1.78,3.71,3.37c1.36,2.81,3.35,6.14,4.72,8.95",
    transform: "translate(11.281 256.991)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(81.483 609.497)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M77.31,363.61c-1-1.5-2.24-2.06-3.69-3.1a7.64,7.64,0,0,1-3.32-4c-.44-1.73.64-3.91,2.42-4s2.93,1.78,3.71,3.37c1.36,2.81,3.35,6.14,4.72,8.95",
    transform: "translate(-70.202 -352.507)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M71.9,362.31c-4.87-1.18-10.4-1.9-15.29-.81-2.37.53-4.94,2-5.13,4.45a4.84,4.84,0,0,0,2.27,4.1c3.33,2.32,7.93,1.53,11.61-.18s7.78-4.71,11.06-6.5",
    transform: "translate(11.281 257.035)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(62.761 617.998)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M71.9,362.31c-4.87-1.18-10.4-1.9-15.29-.81-2.37.53-4.94,2-5.13,4.45a4.84,4.84,0,0,0,2.27,4.1c3.33,2.32,7.93,1.53,11.61-.18s7.78-4.71,11.06-6.5",
    transform: "translate(-51.48 -360.963)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M91.18,369.27a34.441,34.441,0,0,0-14,2.15A10.3,10.3,0,0,0,72,375c-1.77,2.72-.9,6.66,1.55,8.8a9.73,9.73,0,0,0,9.18,1.58,16,16,0,0,0,7.64-5.78,44.772,44.772,0,0,0,5.21-7.73",
    transform: "translate(11.281 257.106)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(82.347 626.324)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M91.18,369.27a34.441,34.441,0,0,0-14,2.15A10.3,10.3,0,0,0,72,375c-1.77,2.72-.9,6.66,1.55,8.8a9.73,9.73,0,0,0,9.18,1.58,16,16,0,0,0,7.64-5.78,44.772,44.772,0,0,0,5.21-7.73",
    transform: "translate(-71.065 -369.218)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M100.46,319.05c-.18-5.46-3-10.08-6.39-14.36-.78-1-1.82-2-3.07-1.93-1.73.08-2.68,2.08-2.86,3.8a11.77,11.77,0,0,0,3,9c2.22,2.4,6,3.54,9.31,3.48",
    transform: "translate(11.281 256.706)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M102.17,335.22a38.638,38.638,0,0,0-5.63-6.78,15.19,15.19,0,0,0-7.77-3.93A9.54,9.54,0,0,0,80.63,327a7,7,0,0,0-1.3,8.12c1.13,2,3.29,3.15,5.45,3.92a25.65,25.65,0,0,0,17.7-.2",
    transform: "translate(11.281 256.835)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M107,354.7a19,19,0,0,0-8.6-6.7,14,14,0,0,0-10.76.38c-1.61.79-3.17,2.2-3.16,4s1.67,3.24,3.29,4.14a22.26,22.26,0,0,0,19.48.89",
    transform: "translate(11.281 256.958)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M85.86,366.41a9.46,9.46,0,0,1-2.61-4.27,2.15,2.15,0,0,1,.06-1.58A1.63,1.63,0,0,1,85.2,360a4.49,4.49,0,0,1,1.68,1.26,50.85,50.85,0,0,1,5.66,8.3",
    transform: "translate(11.281 257.026)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M107,356.51a53.625,53.625,0,0,0-7.08-2.72,51.84,51.84,0,0,0-7.5-1.14,6.87,6.87,0,0,1,2.24-.15,23.46,23.46,0,0,1,5.39.79,23.908,23.908,0,0,1,5.06,2A7.8,7.8,0,0,1,107,356.51Z",
    transform: "translate(11.281 256.962)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M103,338.33a24.293,24.293,0,0,1-2.4-1.33,39.569,39.569,0,0,0-12.12-4.33,18.145,18.145,0,0,1-2.64-.51,10.261,10.261,0,0,1,2.7.15,31.18,31.18,0,0,1,12.24,4.37A10.091,10.091,0,0,1,103,338.33Z",
    transform: "translate(11.281 256.849)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M100.28,318.47a17.309,17.309,0,0,1-1.21-1.8,26.879,26.879,0,0,0-3.41-3.93c-1.48-1.41-2.93-2.58-4-3.44a9.6,9.6,0,0,1-1.63-1.46A8.82,8.82,0,0,1,91.92,309a39.19,39.19,0,0,1,4.1,3.35,19.931,19.931,0,0,1,3.36,4.11,6,6,0,0,1,.9,2.01Z",
    transform: "translate(11.281 256.718)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M93.63,370.53A44.178,44.178,0,0,0,87,373.08a46.38,46.38,0,0,0-5.86,4,6.69,6.69,0,0,1,1.43-1.56,20.77,20.77,0,0,1,9-4.71,6.49,6.49,0,0,1,2.06-.28Z",
    transform: "translate(11.281 257.078)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M72.13,362.75c0,.16-3.16.35-6.91,1.36s-6.59,2.41-6.66,2.27a6.85,6.85,0,0,1,1.8-1.05,28.816,28.816,0,0,1,4.73-1.72,28.1,28.1,0,0,1,5-.87,7.319,7.319,0,0,1,2.04.01Z",
    transform: "translate(11.281 257.022)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M78.58,364.21a16,16,0,0,1-2.23-3.5A17.139,17.139,0,0,1,74.58,357a16.771,16.771,0,0,1,2.23,3.5,17.371,17.371,0,0,1,1.77,3.71Z",
    transform: "translate(11.281 257)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(94.409 616.92)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M85.86,366.41a9.46,9.46,0,0,1-2.61-4.27,2.15,2.15,0,0,1,.06-1.58A1.63,1.63,0,0,1,85.2,360a4.49,4.49,0,0,1,1.68,1.26,50.85,50.85,0,0,1,5.66,8.3",
    transform: "translate(-83.128 -359.895)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M664.87,146.62a36.1,36.1,0,0,0-.8-5.11,20.549,20.549,0,0,0-2.36-5.55,20.82,20.82,0,0,0-25-8.83,19.542,19.542,0,0,0-5.25,2.83,19.3,19.3,0,0,0-4.38,4.41,20.755,20.755,0,0,0,9.63,31.75,20.88,20.88,0,0,0,25-8.83,20.549,20.549,0,0,0,2.36-5.55,36.084,36.084,0,0,0,.8-5.12,1.352,1.352,0,0,1,0,.35c0,.27,0,.6,0,1a9.47,9.47,0,0,1-.13,1.64,14.063,14.063,0,0,1-.39,2.2,19.931,19.931,0,0,1-2.29,5.69,20.9,20.9,0,0,1-5.37,6.1,21.209,21.209,0,0,1-9,4.05,21.46,21.46,0,0,1-11.25-.89,21.475,21.475,0,0,1-9.98-7.45,21.371,21.371,0,1,1,35.59-23.56,19.929,19.929,0,0,1,2.29,5.69,14.056,14.056,0,0,1,.39,2.2,9.445,9.445,0,0,1,.13,1.63c0,.41,0,.74,0,1A1.232,1.232,0,0,1,664.87,146.62Z",
    transform: "translate(4.972 255.699)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M693.21,181.84c-.11.17-7.58-4.64-16.67-10.74s-16.37-11.19-16.26-11.36,7.58,4.64,16.67,10.75S693.32,181.67,693.21,181.84Z",
    transform: "translate(4.972 255.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 85.34,
    height: 110.03,
    transform: "translate(159.39 623.315)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 85.34,
    height: 110.03,
    transform: "translate(131.002 623.315)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M135.87,376.51v-4.77h-8.05v4.77a4,4,0,0,0,3.51,4v4.15h-1.79c-.62,0-1.14.37-1.14.81h6.89c0-.44-.52-.81-1.14-.81h-1.79v-4.15A4,4,0,0,0,135.87,376.51Z",
    transform: "translate(11.281 257.111)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M151.3,376.19a5.87,5.87,0,0,0-5.68-4.45h0a5.87,5.87,0,0,0-5.68,4.45h5.14v7.49a1.144,1.144,0,0,1-2.27,0h-1.1a2.23,2.23,0,1,0,4.46,0v-7.49Z",
    transform: "translate(12.634 257.112)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M232.08,418.52c0,.15-25.61.26-57.2.26s-57.21-.11-57.21-.26,25.61-.26,57.21-.26S232.08,418.38,232.08,418.52Z",
    transform: "translate(12.602 257.34)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M161.12,476.35c-.14,0-.26-24.76-.26-55.31s.12-55.32.26-55.32.26,24.76.26,55.32S161.26,476.35,161.12,476.35Z",
    transform: "translate(12.817 257.447)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 85.34,
    height: 110.03,
    transform: "translate(574.972 568.658)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 85.34,
    height: 110.03,
    transform: "translate(545.531 568.658)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M559.35,322.21v-4.78h-8.06v4.78a4,4,0,0,0,3.52,4v4.16H553c-.63,0-1.14.36-1.14.8h6.88c0-.44-.51-.8-1.14-.8h-1.79V326.2a4,4,0,0,0,3.54-3.99Z",
    transform: "translate(6.536 256.785)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M574.77,321.89a5.87,5.87,0,0,0-5.67-4.46h0a5.87,5.87,0,0,0-5.68,4.46h5.13v7.49a1.144,1.144,0,0,1-2.27,0h-1.09a2.23,2.23,0,1,0,4.46,0v-7.49Z",
    transform: "translate(6.358 256.787)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M655.56,364.22c0,.14-25.62.26-57.2.26s-57.21-.12-57.21-.26,25.61-.26,57.21-.26S655.56,364.08,655.56,364.22Z",
    transform: "translate(4.972 257.019)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M584.6,422.05c-.15,0-.26-24.77-.26-55.31s.11-55.33.26-55.33.26,24.77.26,55.33S584.74,422.05,584.6,422.05Z",
    transform: "translate(6.209 257.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 71.69,
    height: 71.69,
    transform: "translate(492.126 606.716)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 71.69,
    height: 71.69,
    transform: "translate(464.124 606.716)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M476.28,361.63h2.04l-1.75-3.22-1.76-3.23-1.76,3.23-1.76,3.22h2.05v8.11h-5.03v-8.11h2.05l-1.76-3.22-1.76-3.23-1.76,3.23-1.75,3.22h2.04v8.11h-1.19v1.12h13.29v-1.12h-1.19Z",
    transform: "translate(7.551 257.018)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M493.59,421.11c-.15,0-.27-15.9-.27-35.52s.12-35.52.27-35.52.26,15.9.26,35.52S493.73,421.11,493.59,421.11Z",
    transform: "translate(7.296 257.187)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M557.71,385.28c0,.14-22.7.26-50.71.26s-50.72-.12-50.72-.26S479,385,507,385,557.71,385.13,557.71,385.28Z",
    transform: "translate(6.9 257.143)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M689,476.93H264.18A27.94,27.94,0,0,1,236.24,449h0a27.94,27.94,0,0,1,27.94-28H689a27.94,27.94,0,0,1,28,28h0A28,28,0,0,1,689,476.93Z",
    transform: "translate(4.972 257.573)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M691.6,464.82H264.38A15.84,15.84,0,0,1,248.54,449h0a15.84,15.84,0,0,1,15.84-15.84H691.6A15.84,15.84,0,0,1,707.44,449h0a15.84,15.84,0,0,1-15.84,15.82Z",
    transform: "translate(4.972 257.549)",
    fill: "#ebebeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M279.43,449a25,25,0,0,0-.51-3.15,12.93,12.93,0,0,0-4.74-7,12.77,12.77,0,0,0-5.39-2.37,13,13,0,0,0-6.71.57,11.811,11.811,0,0,0-3.23,1.75,11.93,11.93,0,0,0-2.69,2.71,12.69,12.69,0,0,0,0,15.07,12.14,12.14,0,0,0,2.69,2.71,11.78,11.78,0,0,0,3.23,1.74,12.78,12.78,0,0,0,6.71.57,12.531,12.531,0,0,0,5.39-2.37,12.93,12.93,0,0,0,4.74-7,24.644,24.644,0,0,0,.51-3.15,4.811,4.811,0,0,1,0,.83,5.571,5.571,0,0,1-.08,1,8.9,8.9,0,0,1-.24,1.36,12.92,12.92,0,0,1-4.71,7.28,13.081,13.081,0,0,1-5.54,2.51,13.3,13.3,0,0,1-7-.55,12.68,12.68,0,0,1-3.36-1.79,12.439,12.439,0,0,1-2.8-2.81,13.16,13.16,0,0,1,0-15.68,12.24,12.24,0,0,1,2.81-2.8,12.51,12.51,0,0,1,3.35-1.8,13.26,13.26,0,0,1,6.95-.54,13.1,13.1,0,0,1,10.26,9.78,9.121,9.121,0,0,1,.24,1.36,5.7,5.7,0,0,1,.08,1,4.738,4.738,0,0,1,.04.77Z",
    transform: "translate(10.099 257.545)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.7,
    cy: 4.7,
    r: 4.7,
    transform: "translate(271.758 701.808)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M691.63,435.84c0,.15-95.2.27-212.59.27s-212.62-.12-212.62-.27,95.18-.26,212.62-.26S691.63,435.7,691.63,435.84Z",
    transform: "translate(4.972 257.442)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M691.63,462c0,.14-94.8.26-211.71.26s-211.73-.12-211.73-.26,94.78-.26,211.73-.26S691.63,461.84,691.63,462Z",
    transform: "translate(4.972 257.597)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M705.861,477.45c0,.14-149.587.26-334,.26s-334.035-.12-334.035-.26,149.528-.26,334.035-.26S705.861,477.3,705.861,477.45Z",
    transform: "translate(11.281 257.688)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 204.21,
    height: 282.75,
    rx: 6.36,
    transform: "translate(171.532 360.295)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(171.532 360.295)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 204.21,
    height: 282.75,
    rx: 6.36
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 175.55,
    height: 257.73,
    transform: "translate(185.938 375.444)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 175.55,
    height: 252.81,
    transform: "translate(183.487 373.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M349.14,333.46c0-2.11-.1-103.64-.24-252.8l.24.23H173.61l.26-.26c0,94.93,0,182.63-.05,252.8l-.21-.21,175.56.21-175.56.21h-.21v-.21c0-70.17,0-157.87-.05-252.8V80.4H349.4v.24C349.23,229.82,349.14,331.35,349.14,333.46Z",
    transform: "translate(9.906 292.69)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M286.86,333.46s45.11-17.17,61.86-45.65a46.87,46.87,0,0,1-36.05,7.5S300.73,327.18,286.86,333.46Z",
    transform: "translate(10.748 293.392)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M286.86,333.46l.75-.42a20.184,20.184,0,0,0,2.16-1.37,36.169,36.169,0,0,0,6.75-6.76c5.1-6.47,10.87-16.79,15.93-29.68l.08-.19h.19a46.111,46.111,0,0,0,16.33.33c1.43-.18,2.83-.56,4.27-.86a29.563,29.563,0,0,0,4.24-1.3,47.69,47.69,0,0,0,8.25-3.83,29.129,29.129,0,0,0,2.75-1.81l1.08-.83-.7,1.16a71,71,0,0,1-9.69,12.55,106.84,106.84,0,0,1-11,9.8,157.234,157.234,0,0,1-20.8,13.54c-6.18,3.39-11.35,5.79-14.94,7.36-1.8.79-3.22,1.36-4.18,1.73l-1.09.42a2.154,2.154,0,0,1-.39.12,3.091,3.091,0,0,1,.37-.17l1.08-.46c.94-.41,2.34-1,4.13-1.82,3.56-1.63,8.7-4.08,14.85-7.5A159.992,159.992,0,0,0,328,309.92a105.055,105.055,0,0,0,10.91-9.78,71.131,71.131,0,0,0,9.62-12.46l.38.33a32.385,32.385,0,0,1-2.8,1.86,48.622,48.622,0,0,1-8.34,3.86c-1.42.53-2.87.92-4.3,1.32a28.224,28.224,0,0,1-4.32.86,46.509,46.509,0,0,1-16.49-.37l.26-.15c-5.11,12.93-11,23.24-16.15,29.69a34.67,34.67,0,0,1-6.89,6.71A16.208,16.208,0,0,1,286.86,333.46Z",
    transform: "translate(10.752 293.389)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 21.46,
    height: 21.46,
    rx: 3.42,
    transform: "translate(203.772 442.026)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M203.5,163.38h0a.5.5,0,0,1-.36-.18l-3-3.5a.51.51,0,0,1,.06-.71.49.49,0,0,1,.7,0l2.65,3.1,7-7.13a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-7.34,7.52A.55.55,0,0,1,203.5,163.38Z",
    transform: "translate(9.684 292.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M328.66,152.16c0,.15-22.84.26-51,.26s-51-.11-51-.26,22.83-.26,51-.26S328.66,152,328.66,152.16Z",
    transform: "translate(10.258 292.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M269.62,167.86a11.41,11.41,0,0,1-1.69.1l-4.61.08c-3.88.05-9.26.08-15.19.08s-11.31,0-15.2-.08l-4.61-.08a11.34,11.34,0,0,1-1.68-.1,9.822,9.822,0,0,1,1.68-.1l4.61-.09c3.89,0,9.26-.07,15.2-.07s11.31,0,15.19.07l4.61.09a9.889,9.889,0,0,1,1.69.1Z",
    transform: "translate(10.046 292.531)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M328.66,159.12c0,.14-22.84.26-51,.26s-51-.12-51-.26,22.83-.26,51-.26S328.66,159,328.66,159.12Z",
    transform: "translate(10.258 292.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 21.46,
    height: 21.46,
    rx: 3.42,
    transform: "translate(203.772 479.923)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M203.5,201h0a.46.46,0,0,1-.36-.17l-3-3.51a.5.5,0,1,1,.76-.65l2.65,3.09,7-7.12a.5.5,0,1,1,.71.7l-7.34,7.51a.51.51,0,0,1-.42.15Z",
    transform: "translate(9.684 292.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M328.66,189.83c0,.14-22.84.26-51,.26s-51-.12-51-.26,22.83-.26,51-.26S328.66,189.69,328.66,189.83Z",
    transform: "translate(10.258 292.661)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M269.62,205.53a11.41,11.41,0,0,1-1.69.1l-4.61.08c-3.88,0-9.26.08-15.19.08s-11.31,0-15.2-.08l-4.61-.08a11.344,11.344,0,0,1-1.68-.1,10.319,10.319,0,0,1,1.68-.11l4.61-.08c3.89-.05,9.26-.07,15.2-.07s11.31,0,15.19.07l4.61.08A10.39,10.39,0,0,1,269.62,205.53Z",
    transform: "translate(10.046 292.754)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M328.66,196.79c0,.14-22.84.26-51,.26s-51-.12-51-.26,22.83-.26,51-.26S328.66,196.64,328.66,196.79Z",
    transform: "translate(10.258 292.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 21.46,
    height: 21.46,
    rx: 3.42,
    transform: "translate(203.772 517.821)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M203.5,238.71h0a.49.49,0,0,1-.36-.17l-3-3.51a.5.5,0,0,1,.76-.65l2.65,3.09,7-7.12a.5.5,0,1,1,.71.7l-7.34,7.51A.51.51,0,0,1,203.5,238.71Z",
    transform: "translate(9.684 292.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M328.66,227.5c0,.14-22.84.26-51,.26s-51-.12-51-.26,22.83-.26,51-.26S328.66,227.35,328.66,227.5Z",
    transform: "translate(10.258 292.884)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M269.62,243.19a9.89,9.89,0,0,1-1.69.1l-4.61.09c-3.88,0-9.26.07-15.19.07s-11.31,0-15.2-.07l-4.61-.09a9.822,9.822,0,0,1-1.68-.1,11.342,11.342,0,0,1,1.68-.1l4.61-.08c3.89,0,9.26-.08,15.2-.08s11.31,0,15.19.08l4.61.08a11.412,11.412,0,0,1,1.69.1Z",
    transform: "translate(10.046 292.977)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M328.66,234.45c0,.15-22.84.26-51,.26s-51-.11-51-.26,22.83-.26,51-.26S328.66,234.31,328.66,234.45Z",
    transform: "translate(10.258 292.925)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 21.46,
    height: 21.46,
    rx: 3.42,
    transform: "translate(203.772 555.708)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M203.5,276.38h0a.5.5,0,0,1-.36-.18l-3-3.5a.51.51,0,0,1,.06-.71.49.49,0,0,1,.7.06l2.65,3.09,7-7.13a.5.5,0,0,1,.71,0,.49.49,0,0,1,0,.7l-7.34,7.52a.55.55,0,0,1-.42.15Z",
    transform: "translate(9.684 293.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M328.66,265.17c0,.14-22.84.26-51,.26s-51-.12-51-.26,22.83-.27,51-.27S328.66,265,328.66,265.17Z",
    transform: "translate(10.258 293.107)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M269.62,280.86a9.889,9.889,0,0,1-1.69.1l-4.61.08c-3.88,0-9.26.08-15.19.08s-11.31,0-15.2-.08l-4.61-.08a9.819,9.819,0,0,1-1.68-.1,9.819,9.819,0,0,1,1.68-.1l4.61-.08c3.89-.05,9.26-.08,15.2-.08s11.31,0,15.19.08l4.61.08A9.892,9.892,0,0,1,269.62,280.86Z",
    transform: "translate(10.046 293.199)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M328.66,272.12c0,.14-22.84.26-51,.26s-51-.12-51-.26,22.83-.26,51-.26S328.66,272,328.66,272.12Z",
    transform: "translate(10.258 293.148)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M228.87,129.45a2.85,2.85,0,0,1-2.25,1c-1.17,0-2-.45-3.3-1.78a4.35,4.35,0,0,1-4.14-4.4,4.63,4.63,0,0,1,9.26,0,4.31,4.31,0,0,1-3.22,4.24,1.88,1.88,0,0,0,1.44.73,2,2,0,0,0,1.47-.69Zm-5.06-2.13a3,3,0,1,0-3-3,2.93,2.93,0,0,0,3,3Z",
    transform: "translate(9.868 292.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M236.33,122v6.56h-1.46v-.83a2.67,2.67,0,0,1-2.11.92,2.6,2.6,0,0,1-2.83-2.9V122h1.54v3.54c0,1.19.56,1.76,1.54,1.76a1.73,1.73,0,0,0,1.79-2V122Z",
    transform: "translate(9.964 292.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M243.84,124.75v3.84h-1.45v-.79a2.34,2.34,0,0,1-2.07.88c-1.49,0-2.44-.82-2.44-2s.74-1.95,2.73-1.95h1.69v-.1c0-.89-.54-1.42-1.63-1.42a3.21,3.21,0,0,0-2,.65l-.6-1.12a4.61,4.61,0,0,1,2.77-.81C242.74,122,243.84,122.86,243.84,124.75Zm-1.54,1.79v-.76h-1.58c-1.05,0-1.33.39-1.33.87s.47.91,1.25.91a1.67,1.67,0,0,0,1.66-1.02Z",
    transform: "translate(10.041 292.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M245.8,119.48h1.54v9.11H245.8Z",
    transform: "translate(10.104 292.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M249.14,120a.94.94,0,0,1,1-.92.92.92,0,0,1,1,.89,1,1,0,1,1-2,0Zm.21,2h1.54v6.56h-1.54Z",
    transform: "translate(10.138 292.265)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M256.84,128.24a2.44,2.44,0,0,1-1.47.44,2,2,0,0,1-2.26-2.21v-3.16H252v-1.23h1.08v-1.5h1.53v1.5h1.76v1.23h-1.76v3.12c0,.64.32,1,.91,1a1.34,1.34,0,0,0,.86-.27Z",
    transform: "translate(10.175 292.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M264.13,122l-3.07,7.09a2.55,2.55,0,0,1-2.53,1.94,2.71,2.71,0,0,1-1.76-.6l.61-1.13a1.7,1.7,0,0,0,1.13.45c.54,0,.86-.25,1.16-.9l.11-.26L256.92,122h1.59l2.07,4.86,2.07-4.86Z",
    transform: "translate(10.23 292.281)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M267.93,124.29a4.32,4.32,0,0,1,4.51-4.37,4.21,4.21,0,0,1,3.15,1.25l-.58.58a3.42,3.42,0,0,0-2.54-1,3.57,3.57,0,1,0,0,7.13,3.39,3.39,0,0,0,2.54-1l.58.57a4.2,4.2,0,0,1-3.16,1.27,4.32,4.32,0,0,1-4.5-4.43Z",
    transform: "translate(10.341 292.268)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M276.41,125.36a3.29,3.29,0,1,1,3.29,3.3,3.18,3.18,0,0,1-3.29-3.3Zm5.68,0a2.4,2.4,0,1,0-2.39,2.52,2.35,2.35,0,0,0,2.39-2.52Z",
    transform: "translate(10.42 292.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M290.7,124.85v3.74h-.87v-3.66a1.8,1.8,0,0,0-1.94-2.06,2.12,2.12,0,0,0-2.26,2.33v3.39h-.87v-6.46h.83v1.19a2.73,2.73,0,0,1,2.46-1.24,2.47,2.47,0,0,1,2.65,2.77Z",
    transform: "translate(10.499 292.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M296.48,128.2a2.08,2.08,0,0,1-1.37.46,1.71,1.71,0,0,1-1.89-1.88v-3.91h-1.15v-.74h1.15v-1.41h.87v1.41h2v.74h-2v3.86a1,1,0,0,0,1.12,1.18,1.41,1.41,0,0,0,1-.34Z",
    transform: "translate(10.565 292.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M301.31,122.08v.85h-.2a2.09,2.09,0,0,0-2.18,2.38v3.29h-.87v-6.46h.83v1.27a2.45,2.45,0,0,1,2.42-1.33Z",
    transform: "translate(10.619 292.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M302.17,125.36a3.29,3.29,0,1,1,3.3,3.3,3.18,3.18,0,0,1-3.3-3.3Zm5.69,0a2.4,2.4,0,1,0-2.39,2.52,2.35,2.35,0,0,0,2.39-2.52Z",
    transform: "translate(10.672 292.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M310.52,119.48h.88v9.11h-.88Z",
    transform: "translate(10.731 292.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M199,64.92V78.15a13.9,13.9,0,0,0,13.9,13.91H310a13.91,13.91,0,0,0,13.91-13.91V65Z",
    transform: "translate(10.027 291.977)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M261.36,68.83a13,13,0,1,1,13-13A13,13,0,0,1,261.36,68.83Zm0-21.08a8,8,0,1,0,8,8A8,8,0,0,0,261.36,47.75Z",
    transform: "translate(10.21 291.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M621.18,444l5.2,22.12,10.29,17.65a2.54,2.54,0,0,1-1.07,3.56h0a2.5,2.5,0,0,1-2.33,0c-4.62-2.49-21.56-11.74-21.9-13.52-.4-2.07-7.1-25.35-7.1-25.35Z",
    transform: "translate(3.803 257.664)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(615.892 729.899)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M635.6,487.36l-24.68-15.18.28,1a3.84,3.84,0,0,0,1.53,2.15c2,1.36,7.66,5,20.47,12a2.55,2.55,0,0,0,2.4,0Z",
    transform: "translate(-610.92 -472.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(616.757 720.659)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M613.69,463.11a1.55,1.55,0,0,1,.95,1.83,1.48,1.48,0,0,1-1.8.94,1.61,1.61,0,0,1-1-1.93,1.53,1.53,0,0,1,2-.78",
    transform: "translate(-611.784 -463.045)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M627.24,478.42a7.821,7.821,0,0,1,1.58-2.44,8,8,0,0,1,2.61-1.29c0-.06-.35-.16-.93-.09a4.051,4.051,0,0,0-2,1,4,4,0,0,0-1.2,1.91C627.12,478.06,627.18,478.42,627.24,478.42Z",
    transform: "translate(4.972 257.686)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M629.83,481.15c.14.08.7-.91,1.83-1.61a21.8,21.8,0,0,1,2.26-1,2.83,2.83,0,0,0-2.55.49C630.08,479.88,629.69,481.12,629.83,481.15Z",
    transform: "translate(4.972 257.704)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M622.93,475.19a27.6,27.6,0,0,1,2.67-2.68,27.13,27.13,0,0,1,3.32-1.81,7,7,0,0,0-6,4.49Z",
    transform: "translate(4.972 257.666)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M620.48,468c.1.13,1.27-.79,3-1.33s3.18-.5,3.19-.66a6.35,6.35,0,0,0-6.16,2Z",
    transform: "translate(4.972 257.628)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M618.52,461a8.06,8.06,0,0,1,6.45-1.55c0-.06-.32-.29-1-.46a5.53,5.53,0,0,0-4.84,1.17C618.67,460.61,618.47,461,618.52,461Z",
    transform: "translate(4.972 257.586)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M621.17,458.22a2.27,2.27,0,0,0-.22-.91,6.609,6.609,0,0,0-1.37-2.17,2.9,2.9,0,0,0-1.57-1,1,1,0,0,0-1,.53,1.66,1.66,0,0,0-.07,1.18,3.6,3.6,0,0,0,3.92,2.37,4.17,4.17,0,0,0,3.36-3.2,1.4,1.4,0,0,0-.25-1.17,1,1,0,0,0-1.15-.24,3.529,3.529,0,0,0-1.35,1.26,7.311,7.311,0,0,0-1.12,2.31,2.25,2.25,0,0,0-.14.93,11.538,11.538,0,0,1,1.56-3,3.251,3.251,0,0,1,1.21-1.06.51.51,0,0,1,.62.12,1,1,0,0,1,.13.78,3.75,3.75,0,0,1-2.95,2.74,3.12,3.12,0,0,1-3.36-2,1.17,1.17,0,0,1,0-.83.54.54,0,0,1,.57-.3,2.59,2.59,0,0,1,1.34.82,9.71,9.71,0,0,1,1.84,2.84Z",
    transform: "translate(4.972 257.565)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(610.002 705.839)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M605.03,451.09l.94,3.31,16.78-3.69-.56-2.41Z",
    transform: "translate(-605.03 -448.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M554.46,449.81l1.16,17.67S538.05,474.6,538,477.89l34.35-1-.69-27.62Z",
    transform: "translate(3.142 257.635)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(567.732 723.25)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M566.2,465.67a1.41,1.41,0,0,1,1,1.57,1.35,1.35,0,0,1-1.55,1,1.49,1.49,0,0,1-1.07-1.67,1.41,1.41,0,0,1,1.73-.89",
    transform: "translate(-564.561 -465.622)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(541.051 731.783)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M572.3,476.86l-.07-2.76-33,2s-1.51.71-1.3,1.78Z",
    transform: "translate(-537.91 -474.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M555.06,467.32c0,.17.85.22,1.7.74s1.3,1.2,1.45,1.13-.13-1-1.16-1.64S555,467.17,555.06,467.32Z",
    transform: "translate(3.082 257.635)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M551.5,468.92c0,.16.71.43,1.3,1.12s.77,1.44.94,1.43.25-1-.5-1.82S551.5,468.76,551.5,468.92Z",
    transform: "translate(3.042 257.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M549.59,473.29c.15,0,.36-.81-.1-1.72s-1.25-1.24-1.32-1.1.43.62.8,1.37S549.42,473.28,549.59,473.29Z",
    transform: "translate(3.004 257.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M555.24,463.26c.08.16.84-.1,1.79-.06s1.7.31,1.78.16-.64-.72-1.76-.75S555.16,463.14,555.24,463.26Z",
    transform: "translate(3.087 257.603)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(557.709 707.499)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M554.53,450.44l.2,3.14,16.98-.49v-3.13Z",
    transform: "translate(-554.53 -449.96)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M555.07,459.69a3.14,3.14,0,0,0,1.72-.06,7.373,7.373,0,0,0,1.79-.6,8.059,8.059,0,0,0,1-.56,2,2,0,0,0,.51-.42.73.73,0,0,0,.05-.89.93.93,0,0,0-.75-.36,2,2,0,0,0-.64.11,6.293,6.293,0,0,0-1.06.39,6.36,6.36,0,0,0-1.56,1.09,3.968,3.968,0,0,0-1,1.43c0,.03.45-.48,1.25-1.12a7.162,7.162,0,0,1,1.5-.91,7.513,7.513,0,0,1,1-.33c.36-.11.67-.12.77,0s0,.08,0,.19a2.067,2.067,0,0,1-.37.31,8.7,8.7,0,0,1-.9.55,9.581,9.581,0,0,1-1.64.68,13.523,13.523,0,0,0-1.67.5Z",
    transform: "translate(3.097 257.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M555.3,459.93a2.8,2.8,0,0,0,.4-1.68,5.311,5.311,0,0,0-.29-1.87,5.231,5.231,0,0,0-.47-1,1.42,1.42,0,0,0-1.12-.84.82.82,0,0,0-.71.5,2.437,2.437,0,0,0-.15.64,4.067,4.067,0,0,0,0,1.16,4,4,0,0,0,.79,1.75c.7.87,1.4,1.05,1.42,1a6.959,6.959,0,0,1-1.09-1.23,4.08,4.08,0,0,1-.59-1.6,3.648,3.648,0,0,1,0-1c.05-.37.17-.67.31-.64a1.224,1.224,0,0,1,.62.55,5.271,5.271,0,0,1,.46.92,6.248,6.248,0,0,1,.38,1.71C555.37,459.27,555.21,459.91,555.3,459.93Z",
    transform: "translate(3.058 257.573)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M597.61,162.46a3.12,3.12,0,0,0-.41,3.89,10.56,10.56,0,0,0,3,3,7.07,7.07,0,0,1,2.72,3.2c.82,2.5-1,5.34,0,7.78.84,2.12,3.45,3,4.61,5s.53,4.61-.33,6.8-1.92,4.48-1.47,6.79c.25,1.27,1,2.49.81,3.78-.21,1.87-2.09,3-3.87,3.67a17.93,17.93,0,0,1-9.1.7c-2.2-.41-4.46-1.35-5.63-3.25-1-1.62-1-3.65-1-5.57a163.414,163.414,0,0,1,4.1-33",
    transform: "translate(3.533 255.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M535.88,238.14l10.61-25.27s7.39-23,19.16-22.63l2.84,20.7-16.31,35.11-17.49-7.52",
    transform: "translate(3.104 256.134)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M555.52,251.79s-19.17,37.81-18.85,49.64c.18,6.58,10.23,149.31,10.23,149.31h28.92l-5.35-148.88,30.34,149.91,25.61-4.16L606,287.3s-3.5-21.82-10.7-30.77Z",
    transform: "translate(3.583 257.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M569.89,286.22a59.655,59.655,0,0,1,.55,7.81,57.785,57.785,0,0,1,0,7.83,59.664,59.664,0,0,1-.55-7.81,57.845,57.845,0,0,1,0-7.83Z",
    transform: "translate(3.208 256.604)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M607.35,300.85a2.82,2.82,0,0,1-.9.21,14.282,14.282,0,0,1-2.53.09,15.39,15.39,0,0,1-13.23-9,14,14,0,0,1-.84-2.39,3.11,3.11,0,0,1-.14-.92c.1,0,.37,1.27,1.31,3.15a16,16,0,0,0,12.92,8.8C606,301,607.34,300.76,607.35,300.85Z",
    transform: "translate(3.533 256.61)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M548.33,287.1a8.549,8.549,0,0,1-1,2.32,23.889,23.889,0,0,1-3.62,4.92,23.349,23.349,0,0,1-4.77,3.83,8.289,8.289,0,0,1-2.27,1.1,31.469,31.469,0,0,0,11.66-12.17Z",
    transform: "translate(2.962 256.599)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M573.11,452.7a1.871,1.871,0,0,1-.05-.4c0-.29-.06-.67-.1-1.17-.08-1.06-.19-2.57-.33-4.5-.26-3.93-.64-9.58-1.1-16.55-.88-14-2.1-33.31-3.44-54.62s-2.49-40.66-3.26-54.65c-.21-7,.51-12.73,1.75-16.47a11.639,11.639,0,0,1,2.08-4,4.4,4.4,0,0,1,.84-.82l.32-.25a2,2,0,0,1-.29.29,4.742,4.742,0,0,0-.79.84,12.179,12.179,0,0,0-2,4c-1.16,3.73-1.83,9.42-1.58,16.4.88,14,2.09,33.3,3.42,54.62s2.44,40.63,3.29,54.64c.39,7,.71,12.62.93,16.56.1,1.93.18,3.45.23,4.51a7.7,7.7,0,0,0,.05,1.17,2,2,0,0,1,.03.4Z",
    transform: "translate(3.215 257.178)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M624.85,450.07c-.14,0-4.87-33.33-10.56-74.49S604.1,301,604.24,301s4.87,33.32,10.56,74.49S625,450.05,624.85,450.07Z",
    transform: "translate(3.701 257.172)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M594.72,252.84l5.45-27.58,4.21-29.66a27.49,27.49,0,0,0-13.46-6.41l-25.27,1.05-9.52,22.34,1,46.17Z",
    transform: "translate(3.438 256.165)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M593.06,189.66S581,216.45,574.63,218.22c-2.85,11.35-5.38,71.38-5.38,71.38L609,288l-11.75-39L602,229.49s-5.16-30.89.37-36.23C599.23,191.2,596.67,189.88,593.06,189.66Z",
    transform: "translate(3.504 256.255)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M568.49,189.19a102.531,102.531,0,0,0-1,15.89,19.8,19.8,0,0,0,5.39,12.81h0L567.6,289.6l-28.15-4.1s5.81-17.94,10.44-25.75c0,0,2.2-3.71,6.24-10.73,0,0-2.82-22.89-2.92-26.12,0-1.22,7.29-31.32,7.29-31.32a10.54,10.54,0,0,1,7.99-2.39Z",
    transform: "translate(3.15 256.253)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M560.93,155.47c-3.61-.95-5.83-2.23-5.83-3.65,0-2.92,9.44-5.28,21.08-5.28s21.07,2.36,21.07,5.28c0,1.41-2.19,2.69-5.76,3.64",
    transform: "translate(3.378 255.751)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(561.144 403.204)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M562.94,155.37c-3.2-.84-5.25-2-5.16-3.23.22-3.49,8.36-4.69,18.68-4.69s18.67,2.1,18.67,4.69c0,1.24-1.94,2.38-5.11,3.22",
    transform: "translate(-557.777 -147.45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M591.37,152.47c-.44,1.51.65,3,1.9,4s2.75,1.6,3.72,2.83a6.2,6.2,0,0,1,.54,6.09,13.93,13.93,0,0,1-4,5c-1.22,1.06-2.81,2.1-4.34,1.57",
    transform: "translate(3.459 255.811)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M602.35,193.26c-.5,0-2.35,4.71-3.73,9a28.37,28.37,0,0,0,2.31,22.83l8.75,15.38-26.34,8.84,3.86,12.33,36.86-9.89a10.71,10.71,0,0,0,7.34-6.78h0a10.69,10.69,0,0,0-.83-9l-19.22-33S605.11,193.25,602.35,193.26Z",
    transform: "translate(3.724 256.187)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M591.09,154.33a14.24,14.24,0,0,0-15-14A14.53,14.53,0,0,0,562.57,155c0,6.7.09,13.43.47,15.83,1.14,7.22,5.79,9.42,7.63,10a9.3,9.3,0,0,0,2,.2h0v.05l-.39,8.54c.06,5.55,3.81,10,9.36,10s9.23-4.81,9.26-10.38Z",
    transform: "translate(3.346 255.831)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M565.28,158.71a1.16,1.16,0,0,0,1.12,1.17,1.11,1.11,0,0,0,1.2-1,1.15,1.15,0,0,0-1.12-1.17,1.11,1.11,0,0,0-1.2,1Z",
    transform: "translate(3.175 255.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M564.53,156.68c.15.16,1-.5,2.28-.49s2.17.63,2.3.47-.08-.34-.48-.63a3.19,3.19,0,0,0-1.84-.57,3,3,0,0,0-1.81.59C564.59,156.34,564.46,156.62,564.53,156.68Z",
    transform: "translate(3.185 255.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M577.52,158.71a1.16,1.16,0,0,0,1.12,1.17,1.11,1.11,0,0,0,1.2-1,1.16,1.16,0,0,0-1.12-1.17,1.11,1.11,0,0,0-1.2,1Z",
    transform: "translate(3.295 255.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M576.83,156.92c.15.15,1-.5,2.28-.5s2.17.63,2.31.48-.08-.34-.48-.64a3.18,3.18,0,0,0-1.85-.56,3.06,3.06,0,0,0-1.81.58C576.89,156.58,576.76,156.85,576.83,156.92Z",
    transform: "translate(3.305 255.788)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M572.29,166.2a8.079,8.079,0,0,0-2-.37c-.32,0-.62-.09-.68-.31a1.65,1.65,0,0,1,.22-1l.94-2.43a42.164,42.164,0,0,0,2.12-6.37,43.308,43.308,0,0,0-2.63,6.18c-.31.86-.61,1.67-.9,2.45a1.861,1.861,0,0,0-.17,1.25.79.79,0,0,0,.53.47,2.28,2.28,0,0,0,.54.08,8.591,8.591,0,0,0,2.03.05Z",
    transform: "translate(3.224 255.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M572.7,181s4.83.39,10.87-3.24c0,0-1.9,6.39-11,5.54Z",
    transform: "translate(3.311 255.929)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M572.82,169.22a2.23,2.23,0,0,1,2-.84,2.05,2.05,0,0,1,1.42.76,1.3,1.3,0,0,1,.1,1.49,1.5,1.5,0,0,1-1.64.42,4.88,4.88,0,0,1-1.6-1,1.37,1.37,0,0,1-.35-.37.39.39,0,0,1,0-.46",
    transform: "translate(3.259 255.867)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M576,167.07c-.2,0-.2,1.34-1.36,2.31s-2.61.81-2.62,1,.32.26.93.28a3.39,3.39,0,0,0,2.19-.76,3,3,0,0,0,1.06-1.94C576.22,167.39,576.07,167.06,576,167.07Z",
    transform: "translate(3.255 255.861)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M576.27,154.73c.12.34,1.37.18,2.84.35s2.66.58,2.85.27c.09-.14-.12-.46-.6-.79a4.74,4.74,0,0,0-2.11-.74,4.66,4.66,0,0,0-2.22.26C576.49,154.3,576.22,154.56,576.27,154.73Z",
    transform: "translate(3.308 255.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M565,154.13c.22.28,1.08,0,2.12,0s1.92.19,2.12-.1-.05-.43-.44-.7a3.06,3.06,0,0,0-3.41.1C565,153.7,564.89,154,565,154.13Z",
    transform: "translate(3.187 255.772)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M577.93,166.48a.165.165,0,1,1-.06.04",
    transform: "translate(3.283 255.85)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M570.58,149a8,8,0,0,0,5.88,3.42c1.53.12,3.28-.15,4.44.86a6.66,6.66,0,0,1,1.46,3,7.231,7.231,0,0,0,3.1,3.95c1.16.65,2.61.93,3.45,2s.8,2.65.83,4.06.35,3.05,1.62,3.66q.07-7.69.14-15.41a6.13,6.13,0,0,0-.27-2.26c-.62-1.61-2.44-2.38-4.11-2.83-4.72-1.29-9.66-1.44-14.55-1.59",
    transform: "translate(3.368 255.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M558,150.45s3-12.39,3.27-13,3.79-6,12.23-7.58h7s9.9,3.19,11.71,5.6,2.58,14.12,2.58,14.12l-19.56-4.25-13.3,3.24Z",
    transform: "translate(3.365 255.677)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M575.78,128.46h-3a4.85,4.85,0,0,0-1.19,3.15c-.14,2.17-.63,17-.63,17l8.74-.39-.28-18.38,3,.66-.09-1-.79-.93Z",
    transform: "translate(3.299 255.668)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M561.72,151.55l.17-4.5,13.16-3.92L591.49,148v4.84a40.45,40.45,0,0,0-29.77-1.29Z",
    transform: "translate(3.347 255.733)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M562.71,146.09l-.58.57-4.73,3a75,75,0,0,1,18.51-2.46c9.42.1,20.19,3.28,20.19,3.28l-6.24-3.75h0a10.74,10.74,0,0,0-7.63-3.41l-11.83-.23a10.8,10.8,0,0,0-7.69,3Z",
    transform: "translate(3.374 255.727)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M571.17,142.75a39.222,39.222,0,0,1,.09-6.3,38.063,38.063,0,0,1,.61-6.26,39.063,39.063,0,0,1-.09,6.29A38.448,38.448,0,0,1,571.17,142.75Z",
    transform: "translate(3.221 255.662)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M582.4,130.54a11.561,11.561,0,0,1-2.2-.28.57.57,0,0,0-.54.55v1.3c0,.95,0,1.95.07,3v5.47a10.268,10.268,0,0,1-.15,2.26,10.142,10.142,0,0,1-.22-2.26c-.07-1.4-.13-3.33-.17-5.46v-4.33a1,1,0,0,1,1-.89A8.13,8.13,0,0,1,582.4,130.54Z",
    transform: "translate(3.318 255.661)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M557.1,149.57a2.25,2.25,0,0,1,.37-.23c.25-.14.63-.32,1.13-.54s1.11-.45,1.78-.8a5,5,0,0,0,1.92-1.58c.56-.72.64-1.86,1.42-2.82a2.69,2.69,0,0,1,1.62-.93,11.842,11.842,0,0,1,1.88-.17c2.55-.13,5.36-.17,8.31-.09s5.74.26,8.29.48a5.43,5.43,0,0,1,3.47,1.24,9.1,9.1,0,0,1,1,1.33l.44.63.22.3a.76.76,0,0,0,.23.17c1.69.87,3.15,1.48,4.1,2,.48.24.85.44,1.09.58a1.61,1.61,0,0,1,.37.25s-.56-.23-1.55-.65-2.43-1-4.19-1.84a1,1,0,0,1-.35-.26l-.23-.3c-.15-.2-.31-.41-.46-.63a9.218,9.218,0,0,0-1-1.25,5,5,0,0,0-3.22-1.07c-2.53-.2-5.32-.36-8.26-.44s-5.73-.06-8.26,0c-1.26,0-2.54,0-3.2.9s-.81,1.94-1.45,2.76a5.39,5.39,0,0,1-2.09,1.63c-.71.32-1.33.54-1.84.72A15.306,15.306,0,0,1,557.1,149.57Z",
    transform: "translate(3.362 255.723)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M558.87,150.27a1.56,1.56,0,0,1,.29-.25,5.131,5.131,0,0,1,1-.6,16.35,16.35,0,0,1,3.88-1.35,44.1,44.1,0,0,1,13.47-.8c2.62.19,5.14.32,7.41.64a55.279,55.279,0,0,1,6,1.26,22.672,22.672,0,0,1,2.23.72,3.86,3.86,0,0,1,1.55.91,1.53,1.53,0,0,1,.44,1,.6.6,0,0,1-.09.39,1.6,1.6,0,0,0-.49-1.3,3.68,3.68,0,0,0-1.51-.77c-.64-.22-1.39-.44-2.22-.65-1.66-.39-3.69-.82-5.93-1.13s-4.75-.41-7.38-.6a47.45,47.45,0,0,0-13.35.64,19,19,0,0,0-3.87,1.17C559.32,150,558.9,150.33,558.87,150.27Z",
    transform: "translate(3.37 255.746)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M572.56,143.33a4.3,4.3,0,0,1,.62,0h1.7c1.43,0,3.41.14,5.59.32,1.08.09,2.12.19,3.06.3a13.32,13.32,0,0,1,2.49.41,2.42,2.42,0,0,1,1.36,1,1.109,1.109,0,0,1,.19.59,2.673,2.673,0,0,0-.26-.55,2.5,2.5,0,0,0-1.33-.93,15,15,0,0,0-2.47-.36l-3.06-.28c-2.18-.18-4.15-.3-5.58-.38l-1.69-.09A2.6,2.6,0,0,1,572.56,143.33Z",
    transform: "translate(3.342 255.718)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M579.14,141.59a2.528,2.528,0,0,1-.08-.44c0-.28-.09-.7-.15-1.21-.1-1-.21-2.43-.26-4s0-3,0-4a5.789,5.789,0,0,1,.07-1.21,1.882,1.882,0,0,1,.06-.45,2.281,2.281,0,0,1,0,.45v5.21c0,1.56.13,3,.2,4l.08,1.21A1.309,1.309,0,0,1,579.14,141.59Z",
    transform: "translate(3.292 255.659)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M589,147.14a1.64,1.64,0,0,1,.41.13l1.07.42,3.51,1.45a12.858,12.858,0,0,1,1.9.9,2.44,2.44,0,0,1,1.1,1.33,1.65,1.65,0,0,1,0,1.16.761.761,0,0,1-.26.34,1.527,1.527,0,0,0,.18-.37,1.64,1.64,0,0,0,0-1.09,2.29,2.29,0,0,0-1.06-1.21,15,15,0,0,0-1.88-.87l-3.49-1.51-1-.48a2.5,2.5,0,0,1-.48-.2Z",
    transform: "translate(3.451 255.748)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M574.05,128.84a9.729,9.729,0,0,1,1.23-.05h3a21,21,0,0,1,3,.15,1.54,1.54,0,0,1,.81.44.579.579,0,0,1,.16.3,1.42,1.42,0,0,0-1-.59c-.72-.13-1.79-.05-3-.1s-2.2-.05-3-.08a6.508,6.508,0,0,1-1.2-.07Z",
    transform: "translate(3.305 255.628)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M561.72,151.55a19.91,19.91,0,0,0,.85,11.9,42.176,42.176,0,0,1,.68-7.37,9.821,9.821,0,0,1,1.13-3.4c.77-1,2.14-1.24,3.37-1.51s2.59-.46,3-1.64a35.4,35.4,0,0,0-9.08,2",
    transform: "translate(3.189 255.78)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M572.59,183.31a5.58,5.58,0,0,0-3.6,1.6c-.84,1.05-1.37,2.35-2.43,3.17s-2.35,1-3.25,1.88c-1.78,1.71-.91,4.71-1.68,7a17.28,17.28,0,0,1-2.23,3.69,4.57,4.57,0,0,0-.77,4.08,3.55,3.55,0,0,0,2.78,2,7.63,7.63,0,0,0,3.5-.48l-.14-2.78a4,4,0,0,0,.65,1.5,1.37,1.37,0,0,0,1.47.49c.8-.32.82-1.43.74-2.29-.31-3.18-.16-6.61,1.65-9.24.85-1.25,2.3-2.57,3-3.89l.28-6.75",
    transform: "translate(3.195 256.006)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M521.21,233.23s1.79-3.9,4.4-3.74,9.93,1,9.93,1l.81,3.58-16-.82",
    transform: "translate(2.831 256.234)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M528.81,233.27l4.47-13.85a1.73,1.73,0,0,1,1.65-1.2h0a1.74,1.74,0,0,1,1.68,2.21l-3.87,13.62Z",
    transform: "translate(2.858 256.197)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M512.9,233.26h43.44l28.81,39.15-40.63-.59Z",
    transform: "translate(3.175 256.353)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M566.7,247.55a34.472,34.472,0,0,1,5.82-.18c2.27.23,10.82,2.17,10.82,2.17L587,260.89l-4.24-.38-2.85,1.38c-4.55.6-9.78,1.21-10.78,1,0,0-1.71-1-1.2-1.94,0,0-3.88-.45-3.48-3.54a3.22,3.22,0,0,1-2.52-2.79l-7.11-.39a1.42,1.42,0,0,1-1.33-1.29h0c-.07-.8,1-1.08,1.81-1.11l11.09-.48a1.63,1.63,0,0,0,1.22-2.62Z",
    transform: "translate(3.293 256.371)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(572.975 524.417)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M569.94,274.98l33.03-7.06,3.69,12.22-37.17,4.1Z",
    transform: "translate(-569.49 -267.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(544.442 523.362)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M568.59,274.77l-22.2-7.9-5.07,12.02,26.71,4.94Z",
    transform: "translate(-541.32 -266.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M597.2,166.35a1.83,1.83,0,0,1,.09,1.5,4.22,4.22,0,0,1-2.35,2.76,4.33,4.33,0,0,1-3.6-.41,2.269,2.269,0,0,1-1-1.13,5.246,5.246,0,0,0,1.18.81,4.42,4.42,0,0,0,3.23.25,4.22,4.22,0,0,0,2.18-2.39A8.328,8.328,0,0,0,597.2,166.35Z",
    transform: "translate(3.456 255.859)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M597.12,166.08a3.27,3.27,0,0,1-1.09,1.39,4.241,4.241,0,0,1-1.72.91,3.33,3.33,0,0,1-2.41-.26,4.13,4.13,0,0,1-1.67-1.73,5.659,5.659,0,0,1-.58-1.85,4,4,0,0,1,0-1.75,11.341,11.341,0,0,1,.36,1.68,4.67,4.67,0,0,0,2.12,3.19,3,3,0,0,0,2.06.25,4.2,4.2,0,0,0,1.61-.73C596.64,166.57,597.05,166,597.12,166.08Z",
    transform: "translate(3.452 255.841)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M601.68,230.17a2.244,2.244,0,0,1-.28-.3,7.452,7.452,0,0,1-.7-1,27.783,27.783,0,0,1-2.19-3.73,31.87,31.87,0,0,1-.27-27.69,27.726,27.726,0,0,1,2.12-3.78,11.509,11.509,0,0,1,.68-.95c.16-.22.26-.32.27-.31a13.132,13.132,0,0,1-.78,1.37,35,35,0,0,0-1.95,3.82,33.61,33.61,0,0,0,2.29,31.16,13.907,13.907,0,0,1,.81,1.41Z",
    transform: "translate(3.499 256.099)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M573.75,222.19a8.339,8.339,0,0,1,1.18-1,40.368,40.368,0,0,0,3.12-2.75,49.509,49.509,0,0,0,8.24-10.93,107.511,107.511,0,0,0,5.88-12.44c.65-1.56,1.19-2.86,1.6-3.86a8.423,8.423,0,0,1,.64-1.39,8.182,8.182,0,0,1-.45,1.46c-.33.94-.81,2.28-1.45,3.93a92.67,92.67,0,0,1-5.76,12.56,45.909,45.909,0,0,1-8.44,10.93,29.565,29.565,0,0,1-3.26,2.65c-.4.3-.73.49-.95.63a1.291,1.291,0,0,1-.35.21Z",
    transform: "translate(3.397 256.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M565.64,190.56c.1,0-.46,1.71-.86,4.53a33.114,33.114,0,0,0-.31,5,36.258,36.258,0,0,0,.66,6.06,36.876,36.876,0,0,0,1.75,5.84,33,33,0,0,0,2.22,4.46c1.46,2.44,2.63,3.78,2.55,3.84a5.271,5.271,0,0,1-.86-.91,12,12,0,0,1-.9-1.14c-.34-.47-.74-1-1.11-1.6a30.01,30.01,0,0,1-2.34-4.47,31.332,31.332,0,0,1-2.44-12.1,29.324,29.324,0,0,1,.42-5c.09-.71.27-1.34.39-1.9a13.582,13.582,0,0,1,.39-1.41,5.169,5.169,0,0,1,.44-1.2Z",
    transform: "translate(3.202 256.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M562,188.8c.14,0-1.5,7.92-3.66,17.63s-4,17.55-4.18,17.52,1.5-7.93,3.67-17.64S561.86,188.77,562,188.8Z",
    transform: "translate(3.107 256.07)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M511.6,181.84l3.33-11.6s1.21-4.71,1.5-5.81c.37-1.46-.64-1.93-1.26-.94-.23.38-2.83,5.16-2.83,5.16l2.19-8.14c.68-2.56-.92-2.31-1.39-1.4s-3.44,8.67-3.44,8.67c2.79-10.1,2-11,1.2-11.17s-3.23,9.07-3.23,9.07a8.55,8.55,0,0,0-2.42-2.69c-2.43-1.71-6.52-.06-6.73,1.09s1.25,1.48,1.25,1.48a3.68,3.68,0,0,1,5.85,3.4,2.29,2.29,0,0,1-4.49.39c-1-4.57-2.56-3.11-2.56-3.11l1.49,10.09-1.72,5",
    transform: "translate(7.675 255.849)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M457.6,141.72c3.79-1,6.13-2.36,6.13-3.84,0-3.08-9.94-5.57-22.19-5.57s-22.19,2.49-22.19,5.57c0,1.48,2.3,2.82,6.07,3.82",
    transform: "translate(7.043 255.667)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(428.615 388.941)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M455.48,141.61c3.37-.89,5.52-2.09,5.43-3.41-.23-3.66-8.8-4.93-19.67-4.93s-19.66,2.21-19.66,4.93c0,1.32,2,2.51,5.38,3.39",
    transform: "translate(-421.58 -133.27)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M460.68,136.43s-3.18-13-3.45-13.68-4-6.35-12.88-8H437s-10.43,3.36-12.33,5.9S422,135.54,422,135.54l20.59-4.48,14,3.41Z",
    transform: "translate(7.036 255.588)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M442,113.28h3.15a5.09,5.09,0,0,1,1.26,3.31c.14,2.28.66,17.95.66,17.95l-9.21-.42.3-19.35-3.13.7.1-1.1.83-1Z",
    transform: "translate(7.009 255.579)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M393.68,439.71l-6.07,24.06-10.28,17.65A2.54,2.54,0,0,0,378.4,485h0a2.55,2.55,0,0,0,2.33,0c4.61-2.49,21.56-11.74,21.9-13.53.4-2.06,8.08-25,8.08-25Z",
    transform: "translate(6.548 257.646)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(384.915 727.525)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M378.4,485l24.68-15.18-.28,1a3.87,3.87,0,0,1-1.54,2.15c-2,1.37-7.65,5-20.46,12a2.52,2.52,0,0,1-2.4,0Z",
    transform: "translate(-378.4 -469.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(405.921 718.258)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M400.3,460.73a1.54,1.54,0,0,0-.94,1.82,1.47,1.47,0,0,0,1.8.95,1.62,1.62,0,0,0,1-1.94,1.54,1.54,0,0,0-2-.78",
    transform: "translate(-399.312 -460.659)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M386.75,476a7.61,7.61,0,0,0-1.58-2.44,7.92,7.92,0,0,0-2.61-1.29c0-.06.35-.16.93-.09a3.91,3.91,0,0,1,2,1,4,4,0,0,1,1.21,1.91C386.88,475.67,386.82,476,386.75,476Z",
    transform: "translate(6.453 257.672)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M384.17,478.77c-.15.07-.7-.92-1.84-1.61a21.146,21.146,0,0,0-2.25-1,2.81,2.81,0,0,1,2.54.49C383.91,477.5,384.31,478.74,384.17,478.77Z",
    transform: "translate(6.428 257.69)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M391.06,472.81a25.617,25.617,0,0,0-2.66-2.68,24.9,24.9,0,0,0-3.32-1.81,5.63,5.63,0,0,1,3.65,1.37,5.7,5.7,0,0,1,2.33,3.12Z",
    transform: "translate(6.486 257.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M393.52,465.65c-.11.13-1.28-.79-3-1.33s-3.18-.5-3.19-.66a4.87,4.87,0,0,1,3.36.14,4.94,4.94,0,0,1,2.83,1.85Z",
    transform: "translate(6.509 257.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M395.47,458.63a12.6,12.6,0,0,0-3.06-1.46,12.141,12.141,0,0,0-3.39-.08c0-.07.32-.29,1-.46a5.6,5.6,0,0,1,4.85,1.16C395.32,458.23,395.52,458.59,395.47,458.63Z",
    transform: "translate(6.527 257.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M392.83,455.84a2.1,2.1,0,0,1,.21-.91,6.57,6.57,0,0,1,1.38-2.17,2.85,2.85,0,0,1,1.56-1,1,1,0,0,1,1,.52,1.64,1.64,0,0,1,.08,1.19,3.58,3.58,0,0,1-3.92,2.36,4.16,4.16,0,0,1-3.37-3.19,1.47,1.47,0,0,1,.26-1.18,1,1,0,0,1,1.15-.23,3.53,3.53,0,0,1,1.35,1.26,7.28,7.28,0,0,1,1.12,2.3,2.28,2.28,0,0,1,.14.93,11.45,11.45,0,0,0-1.57-3,3.33,3.33,0,0,0-1.2-1.07.54.54,0,0,0-.63.13,1,1,0,0,0-.12.78,3.71,3.71,0,0,0,2.95,2.73,3.11,3.11,0,0,0,3.36-2,1.29,1.29,0,0,0,0-.83.56.56,0,0,0-.58-.29,2.52,2.52,0,0,0-1.34.82,9.63,9.63,0,0,0-1.83,2.85Z",
    transform: "translate(6.539 257.551)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M458.35,446.61,457,465.81s19.07,7.8,19.17,11.37l-37.31-1.24.84-30Z",
    transform: "translate(7.2 257.625)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M445.54,463.81a1.51,1.51,0,0,0-1.11,1.7,1.46,1.46,0,0,0,1.68,1.12,1.6,1.6,0,0,0,1.16-1.81,1.52,1.52,0,0,0-1.87-1",
    transform: "translate(7.049 257.618)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(446.08 730.618)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M438.88,475.94l.2-3,35.7,2.32s1.64.78,1.41,1.94Z",
    transform: "translate(-438.88 -472.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M457.63,465.64c0,.18-.92.24-1.84.79s-1.42,1.31-1.58,1.23.14-1.12,1.26-1.77S457.68,465.48,457.63,465.64Z",
    transform: "translate(7.147 257.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M461.49,467.39c0,.18-.76.46-1.4,1.21s-.85,1.56-1,1.55-.26-1,.56-2S461.5,467.22,461.49,467.39Z",
    transform: "translate(7.188 257.639)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M463.56,472.15c-.17,0-.39-.89.11-1.87s1.37-1.35,1.44-1.2-.47.67-.87,1.49S463.74,472.14,463.56,472.15Z",
    transform: "translate(7.226 257.65)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M457.45,461.23c-.08.17-.91-.11-1.94-.08s-1.84.34-1.93.18.7-.79,1.92-.81S457.55,461.09,457.45,461.23Z",
    transform: "translate(7.144 257.591)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M457.65,457.36a3.59,3.59,0,0,1-1.87-.08,7.75,7.75,0,0,1-1.93-.66,8.23,8.23,0,0,1-1.06-.61,2,2,0,0,1-.55-.46.8.8,0,0,1-.05-1,1,1,0,0,1,.81-.39,2.669,2.669,0,0,1,.7.12,7.426,7.426,0,0,1,1.15.44,6.53,6.53,0,0,1,1.68,1.19c.84.83,1.12,1.52,1.05,1.55s-.48-.52-1.34-1.22a7.558,7.558,0,0,0-1.64-1,7.749,7.749,0,0,0-1.06-.37c-.39-.11-.73-.13-.84,0s0,.1,0,.22a2.5,2.5,0,0,0,.4.33,8.53,8.53,0,0,0,1,.6,11.274,11.274,0,0,0,1.78.75,11.677,11.677,0,0,1,1.77.59Z",
    transform: "translate(7.139 257.563)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M457.4,457.61a3.08,3.08,0,0,1-.43-1.82,6.1,6.1,0,0,1,.32-2,6.239,6.239,0,0,1,.52-1.12,1.52,1.52,0,0,1,1.22-.9.86.86,0,0,1,.76.54,2.221,2.221,0,0,1,.17.7,4,4,0,0,1,0,1.25,4.33,4.33,0,0,1-.86,1.91c-.76.94-1.53,1.13-1.54,1.07a7.434,7.434,0,0,0,1.18-1.33,4.42,4.42,0,0,0,.65-1.74,4.343,4.343,0,0,0,0-1.08c-.05-.4-.19-.72-.34-.69a1.311,1.311,0,0,0-.67.59,6.658,6.658,0,0,0-.5,1,6.818,6.818,0,0,0-.42,1.85C457.33,456.9,457.5,457.58,457.4,457.61Z",
    transform: "translate(7.172 257.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M427.72,186.51l22.43-1c.13-2.38-1.09-17.1-1.09-17.1s8.48-1.32,8.59-9.8-1.18-25.41-1.18-25.41l-.15-.74c-9.81-4.21-21.18-4.59-29.64,1.93l-1.26,1Z",
    transform: "translate(7.032 255.757)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M449.08,168.25A19.7,19.7,0,0,1,438,165.11s2.62,6.1,11.08,5.34Z",
    transform: "translate(7.033 255.854)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M426.46,144.1c-.14-.06-5.82-1.72-5.64,4.08s6,4.41,6,4.25S426.46,144.1,426.46,144.1Z",
    transform: "translate(6.836 255.735)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M425,150.29a1.5,1.5,0,0,1-.26.15,1,1,0,0,1-.76,0,2.48,2.48,0,0,1-1.22-2.2,3.3,3.3,0,0,1,.23-1.46,1.17,1.17,0,0,1,.74-.8.52.52,0,0,1,.6.26c.08.16.05.28.08.29s.12-.1.07-.34a.66.66,0,0,0-.24-.36.75.75,0,0,0-.56-.13,1.42,1.42,0,0,0-1,.94,3.4,3.4,0,0,0-.3,1.62,2.65,2.65,0,0,0,1.55,2.46,1.1,1.1,0,0,0,.92-.18A.323.323,0,0,0,425,150.29Z",
    transform: "translate(6.832 255.738)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M453.5,143.77a1.2,1.2,0,0,1-1.16,1.22,1.15,1.15,0,0,1-1.25-1.09,1.21,1.21,0,0,1,1.16-1.22,1.15,1.15,0,0,1,1.25,1.09Z",
    transform: "translate(7.111 255.714)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M454.68,142.56c-.15.16-1.07-.52-2.37-.52s-2.26.66-2.4.5.08-.36.5-.66a3.29,3.29,0,0,1,1.92-.59,3.17,3.17,0,0,1,1.89.61C454.62,142.2,454.75,142.49,454.68,142.56Z",
    transform: "translate(7.113 255.703)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M440.7,144.23a1.21,1.21,0,0,1-1.17,1.22,1.16,1.16,0,0,1-1.25-1.09,1.22,1.22,0,0,1,1.17-1.23A1.18,1.18,0,0,1,440.7,144.23Z",
    transform: "translate(6.986 255.716)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M441.87,142.8c-.15.16-1.07-.52-2.37-.51s-2.26.65-2.4.49.08-.35.5-.66a3.36,3.36,0,0,1,1.92-.59,3.14,3.14,0,0,1,1.89.61C441.81,142.45,442,142.73,441.87,142.8Z",
    transform: "translate(6.988 255.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M446.6,152.47a8.059,8.059,0,0,1,2.12-.39c.33,0,.64-.1.7-.32a1.7,1.7,0,0,0-.22-1c-.31-.81-.64-1.65-1-2.53a45.49,45.49,0,0,1-2.21-6.63,42.666,42.666,0,0,1,2.74,6.43c.33.89.65,1.74.94,2.55a1.91,1.91,0,0,1,.18,1.31.82.82,0,0,1-.55.48,2,2,0,0,1-.56.08,9.11,9.11,0,0,1-2.14.02Z",
    transform: "translate(7.07 255.726)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M442.77,153.37c.21,0,.21,1.4,1.42,2.4a6.425,6.425,0,0,0,2.73,1c.01.15-.34.27-1,.29a3.54,3.54,0,0,1-2.28-.79,3,3,0,0,1-1.1-2C442.51,153.71,442.67,153.36,442.77,153.37Z",
    transform: "translate(7.039 255.78)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M442.21,137.7c-.13.35-1.43.18-3,.37s-2.76.6-3,.28c-.09-.15.13-.48.63-.83a4.93,4.93,0,0,1,2.2-.77,5,5,0,0,1,2.31.27C442,137.25,442.26,137.53,442.21,137.7Z",
    transform: "translate(6.986 255.677)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M454.2,138.79c-.23.3-1.13,0-2.21,0s-2,.2-2.2-.11c-.09-.15,0-.44.45-.72a3.165,3.165,0,0,1,3.55.11C454.18,138.34,454.3,138.64,454.2,138.79Z",
    transform: "translate(7.11 255.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M466.4,266.93l-3.71,191.55a2.35,2.35,0,0,1-2.37,2.31l-22.31-.2a2.35,2.35,0,0,1-2.33-2.4l3.46-164.87L410.12,457a4.22,4.22,0,0,1-4.3,3.48l-18.71-.65a4.21,4.21,0,0,1-4-4.86l29.39-188.8Z",
    transform: "translate(6.897 257.118)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M512,181.59l-13.87-3.34L489,203.08l-25.29-22.63h0c-2.69-2-7.33-2.22-10.86-2.65h-.27c-1.37-.17-2-.36-2.86-.46-6.1,4.58-16.53,4.87-22.52.14,0,0-4.54,1-7.25,1.55-8.54,1.64-14.69,7.86-16.39,13.6l10.69,24.65,2.05,23.42-5.92,21a3.63,3.63,0,0,0,3,4.6l53,.81.86-.43c1.12-2.06,1.94-4.43,1.42-6.71-2.28-10-.69-40-1.17-49.14,10.39,10.09,21.85,18.46,30.22,13.28C504.69,219.74,512,181.59,512,181.59Z",
    transform: "translate(7.294 256.146)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M427.62,176.87Z",
    transform: "translate(6.869 255.911)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M425.51,138.65c.22,2.35.15,4.73.38,7.08a8,8,0,0,0,.84,2.54,2.33,2.33,0,0,0,4.42,0,6.93,6.93,0,0,0,.52-3,9.619,9.619,0,0,1,.32-3.08,16.769,16.769,0,0,1,1.75-3,3.73,3.73,0,0,0,.55-3.3c-3.15-.06-6.05,1.21-8.78,2.77",
    transform: "translate(6.898 255.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M456.76,137.59l-.18-4.74-13.86-4.13-17.3,5.1v5.1a42.56,42.56,0,0,1,31.34-1.33Z",
    transform: "translate(7.027 255.648)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M455.71,131.84l.61.59,5,3.14a78.691,78.691,0,0,0-19.5-2.57c-9.92.1-21.26,3.45-21.26,3.45l6.57-4h0a11.25,11.25,0,0,1,8-3.58l12.45-.25a11.3,11.3,0,0,1,8.13,3.22Z",
    transform: "translate(7.034 255.642)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M446.81,128.32a42.265,42.265,0,0,1-.63-6.6,43.586,43.586,0,0,1-.11-6.63,40.876,40.876,0,0,1,.63,6.6A43.594,43.594,0,0,1,446.81,128.32Z",
    transform: "translate(7.053 255.573)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M435,115.47a8.87,8.87,0,0,1,2.34-.68,1,1,0,0,1,1,.93v4.56c0,2.25-.1,4.28-.17,5.75a11.483,11.483,0,0,1-.23,2.38,11,11,0,0,1-.14-2.38v-5.75c0-1.11.05-2.17.07-3.16a12.279,12.279,0,0,1,.05-1.37.63.63,0,0,0-.59-.59,13.69,13.69,0,0,1-2.33.31Z",
    transform: "translate(6.959 255.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M461.62,135.51s-.58-.24-1.65-.62c-.53-.2-1.19-.42-1.93-.77a5.48,5.48,0,0,1-2.2-1.71c-.67-.86-.79-2.06-1.53-2.91s-2.05-.9-3.37-.95c-2.67-.11-5.62-.14-8.7-.05s-6,.25-8.7.46a5.29,5.29,0,0,0-3.4,1.13,9.433,9.433,0,0,0-1,1.32l-.48.67-.25.31a1.21,1.21,0,0,1-.36.27c-1.85.9-3.37,1.47-4.41,1.94a14,14,0,0,1-1.62.69c-.01-.03.12-.11.38-.26s.65-.36,1.15-.61c1-.52,2.54-1.17,4.32-2.08a1.081,1.081,0,0,0,.25-.18l.23-.31c.15-.22.31-.44.46-.67a10,10,0,0,1,1.07-1.4,5.69,5.69,0,0,1,3.66-1.3c2.67-.23,5.62-.42,8.72-.51s6.06,0,8.74.1a13.258,13.258,0,0,1,2,.18,2.76,2.76,0,0,1,1.69,1c.82,1,.91,2.2,1.5,3a5.27,5.27,0,0,0,2,1.67c.71.36,1.35.61,1.88.84s.92.42,1.18.56S461.63,135.49,461.62,135.51Z",
    transform: "translate(7.041 255.637)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M459.77,136.24a2.67,2.67,0,0,1-.37-.18,8.442,8.442,0,0,0-1-.53,20.2,20.2,0,0,0-4.08-1.24,50,50,0,0,0-14.06-.68c-2.78.2-5.41.32-7.78.63a59.545,59.545,0,0,0-6.24,1.2c-.87.22-1.66.45-2.34.68a3.89,3.89,0,0,0-1.58.82,1.67,1.67,0,0,0-.52,1.37.66.66,0,0,1-.09-.41,1.64,1.64,0,0,1,.46-1.1,4.06,4.06,0,0,1,1.63-1c.68-.26,1.47-.52,2.35-.76a57.412,57.412,0,0,1,6.27-1.32c2.39-.34,5-.48,7.8-.68a46.34,46.34,0,0,1,14.18.84,17.231,17.231,0,0,1,4.08,1.42,5.239,5.239,0,0,1,1,.62,1.69,1.69,0,0,1,.29.32Z",
    transform: "translate(7.029 255.662)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M443.78,113.68a8.662,8.662,0,0,1-1.29.1l-3.13.08a27.712,27.712,0,0,0-3.1.1,1.5,1.5,0,0,0-1.05.63.528.528,0,0,1,.16-.31,1.52,1.52,0,0,1,.85-.46,21.686,21.686,0,0,1,3.14-.16h3.12a7.34,7.34,0,0,1,1.3.02Z",
    transform: "translate(6.991 255.539)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M445.35,128.93a3,3,0,0,1-.66.06l-1.78.1c-1.5.08-3.58.2-5.87.39l-3.23.3a15.219,15.219,0,0,0-2.59.38,2.62,2.62,0,0,0-1.41,1,2.43,2.43,0,0,0-.27.59,1.341,1.341,0,0,1,.2-.63,2.64,2.64,0,0,1,1.43-1.08,13.9,13.9,0,0,1,2.62-.43c1-.11,2.09-.22,3.23-.32,2.3-.19,4.38-.29,5.88-.33h1.79A5,5,0,0,1,445.35,128.93Z",
    transform: "translate(6.977 255.633)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M438.41,127.1a2.414,2.414,0,0,1,0-.47c0-.42.06-.84.09-1.28.07-1.07.16-2.56.21-4.2s0-3.14,0-4.22v-1.28a1.35,1.35,0,0,1,0-.47,3.2,3.2,0,0,1,.06.47c0,.3.05.74.07,1.28.05,1.08.07,2.57,0,4.22s-.16,3.14-.27,4.22a6.669,6.669,0,0,1-.15,1.27A1.5,1.5,0,0,1,438.41,127.1Z",
    transform: "translate(6.976 255.571)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M428,132.94a2.85,2.85,0,0,1-.39.21l-1.1.51-3.67,1.58a15.309,15.309,0,0,0-2,.92,2.53,2.53,0,0,0-1.13,1.28,1.82,1.82,0,0,0,0,1.15,3.1,3.1,0,0,0,.2.39.9.9,0,0,1-.27-.36,1.84,1.84,0,0,1,0-1.23A2.61,2.61,0,0,1,420.8,136a13.257,13.257,0,0,1,2-.95l3.69-1.53,1.13-.44a2.617,2.617,0,0,1,.38-.14Z",
    transform: "translate(6.837 255.664)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M425.51,178.99l1.23-8.47,11.54,4.23,3.26,5.74,2.02-6.3,6.33-2.18,2.71,5.64-4.65,6.57-8.71,1.76Z",
    transform: "translate(7.002 255.91)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M441.74,181.81a2.637,2.637,0,0,1-.43-.35,15,15,0,0,1-1.06-1.14,17.06,17.06,0,0,1-2.79-4.81h.43l-2.67,6.72c-.46,1.15-.91,2.26-1.34,3.32l-.14.35-.27-.26c-2.33-2.25-4.34-4.23-5.76-5.65l-1.65-1.68a3.111,3.111,0,0,1-.55-.65,2.941,2.941,0,0,1,.67.53l1.75,1.57c1.48,1.36,3.54,3.28,5.89,5.51l-.41.09c.42-1.06.87-2.17,1.33-3.32l2.73-6.7.22-.55.2.56a18.781,18.781,0,0,0,2.57,4.79C441.25,181.22,441.78,181.77,441.74,181.81Z",
    transform: "translate(6.939 255.925)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M452.6,177.65a9.14,9.14,0,0,1-1.35,1.86,18.491,18.491,0,0,1-4.42,3.89l-.26.15-.1-.28c-.38-1-.82-2.14-1.28-3.29-.69-1.73-1.34-3.37-1.85-4.83h.45c-.38,1.91-.85,3.48-1.14,4.58a10.8,10.8,0,0,1-.5,1.74,7.38,7.38,0,0,1,.23-1.8c.21-1.13.62-2.71.95-4.6l.15-.85.3.81c.53,1.44,1.2,3.06,1.89,4.79.47,1.16.9,2.28,1.26,3.32l-.36-.13a21.491,21.491,0,0,0,4.45-3.66,17.575,17.575,0,0,1,1.58-1.7Z",
    transform: "translate(7.07 255.917)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M445.93,268.09a5.275,5.275,0,0,1,.05-.88q.11-.93.27-2.52c.15-1.09.23-2.44.34-4q.09-1.17.18-2.49c0-.89.07-1.83.11-2.81.18-3.93.17-8.61.08-13.81s-.42-10.92-.83-16.91c-.87-12-2.05-22.8-2.94-30.62-.44-3.88-.8-7-1.06-9.27q-.17-1.59-.27-2.52a6.431,6.431,0,0,1-.06-.88,4.433,4.433,0,0,1,.17.87c.09.62.21,1.45.36,2.51.31,2.18.74,5.34,1.23,9.24,1,7.82,2.22,18.64,3.09,30.63.41,6,.68,11.73.79,16.94s0,9.9-.19,13.84c-.05,1-.1,1.92-.15,2.81s-.15,1.71-.22,2.5c-.14,1.56-.25,2.9-.43,4l-.36,2.51a8.143,8.143,0,0,1-.16.86Z",
    transform: "translate(7.039 256.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M436.67,178.61l2.62,1.37-.49,4.41-4.08-.86Z",
    transform: "translate(6.964 255.935)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(441.684 434.545)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M436.67,178.61l2.62,1.37-.49,4.41-4.08-.86Z",
    transform: "translate(-434.72 -178.61)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M442.68,179.7l1.98-1.74,1.82,4.61-2.6,1.25Z",
    transform: "translate(7.037 255.931)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M439.78,185.46l-1.22,52.18,8.82,8.72,4.26-11.58-8.46-49.59Z",
    transform: "translate(7.05 256.117)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M439.84,178.36c.6-.07,1.43-.23,2.08-.37a1.46,1.46,0,0,1,1.58.73l1.11,2.05a1.49,1.49,0,0,1,.15,1l-.45,2.3a1.45,1.45,0,0,1-1.13,1.15l-2.52.51a1.45,1.45,0,0,1-1.58-.77l-1.26-2.48a1.42,1.42,0,0,1,0-1.24l.87-2a1.46,1.46,0,0,1,1.15-.88Z",
    transform: "translate(7.007 255.936)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M443.5,178.92a5.479,5.479,0,0,1-.67.83c-.43.5-1,1.18-1.72,1.91l-1.77,1.88a5.943,5.943,0,0,1-.78.73,4.788,4.788,0,0,1,.66-.83c.44-.5,1-1.18,1.73-1.92s1.31-1.4,1.77-1.87a5.935,5.935,0,0,1,.78-.73Z",
    transform: "translate(7.003 255.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M440.92,181.32a12.232,12.232,0,0,1-2.28-2.19,12.229,12.229,0,0,1,2.28,2.19Z",
    transform: "translate(6.989 255.929)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M443.87,184.66a28.36,28.36,0,0,1,.62-3,2.94,2.94,0,0,0-.63-2,1.69,1.69,0,0,1-.3-.86,4.208,4.208,0,0,0,.43.78,9.52,9.52,0,0,1,.51.85,1.91,1.91,0,0,1,.2,1.22c-.17.86-.39,1.58-.54,2.12a3.5,3.5,0,0,1-.29.89Z",
    transform: "translate(7.03 255.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(420.982 487.336)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M414.23,250.93a10,10,0,0,0,8.71,2.5c2.19-.44,4.27-1.63,6.5-1.49,2.45.16,4.47,1.87,6.7,2.88,4.16,1.89,9,1.29,13.44.11,2-.54,4.15-1.28,5.46-2.92a9.7,9.7,0,0,0,1.68-4.54,46.7,46.7,0,0,0,.66-9,8.353,8.353,0,0,0-1.45-5.37,6.21,6.21,0,0,0-4-2,15.811,15.811,0,0,0-4.6.26A76,76,0,0,0,414,245.62",
    transform: "translate(-414 -231.036)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M435.71,241s-28,12.53-30.87,13.16c-9.46,2.07-20.28-6.86-17.27-17.05,1.11-3.79,16.19-45.69,16.19-45.69l14.35,19.83L412,231.53l15.89-1.06Z",
    transform: "translate(6.734 256.161)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M426.64,230.64a5.682,5.682,0,0,1-1.11.15l-3.07.26c-2.6.21-6.25.46-10.41.72h-.35l.1-.34c.31-1,.62-2.07.94-3.14,1.42-4.74,2.73-9,3.7-12.11.47-1.47.87-2.7,1.17-3.65a7.873,7.873,0,0,1,.5-1.32,8,8,0,0,1-.31,1.37c-.27,1-.61,2.21-1,3.7-.88,3.12-2.14,7.41-3.55,12.15-.33,1.08-.64,2.13-1,3.14l-.25-.31c4.16-.25,7.81-.44,10.42-.55l3.08-.12A5.13,5.13,0,0,1,426.64,230.64Z",
    transform: "translate(6.795 256.167)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M432.58,242.62c.05.13-6.1,2.79-13.74,5.93S405,254.15,404.91,254s6.1-2.79,13.74-5.94S432.53,242.5,432.58,242.62Z",
    transform: "translate(6.798 256.331)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M429.19,229.71,427,219a1.38,1.38,0,0,1,1.36-1.66l27.85.13a1.39,1.39,0,0,1,1.37,1.54l-2.88,24.65a1.91,1.91,0,0,1-1.92,1.7l-18.16-.14a1.93,1.93,0,0,1-1.85-1.45Z",
    transform: "translate(7.038 256.225)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M426.74,224.05h0a2.91,2.91,0,0,1,2.73,1.86c.46,1.19,1.13,2.58,1.87,3,1.37.75,3.73,1.34,5,.74s6.22-5.09,7.09-4.59,1.61,1.62.74,2.61-5.47,4-4.6,5,10.57-3.38,12.06-3,2.36,1.3,1.49,1.9-7.46,3.08-7.83,3.95c0,0,9.95-2.61,10.32-2s1,1.62,0,2-9.57,2.61-10.32,3a18.18,18.18,0,0,1-3.83,1.11c-.27,0-2.22.66-4,1.27a8.77,8.77,0,0,1-6.18-.16l-1-.41a3.94,3.94,0,0,1-2.45-3.89L428,233l-1.08-2.8Z",
    transform: "translate(7.028 256.236)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M443.45,221.44a1,1,0,1,1-1-1A1,1,0,0,1,443.45,221.44Z",
    transform: "translate(7.015 256.174)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 11.4,
    height: 3.69,
    transform: "translate(458.012 460.352)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M423.65,273.1l-12.11-.3.57-3.67,11.96.47Z",
    transform: "translate(6.78 256.468)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M457.27,273.02l-30.42-.22.4-3.36,29.99.08Z",
    transform: "translate(7.036 256.468)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M438.94,269.24v4.05a1.11,1.11,0,0,0,1,1.19h8.38a1.11,1.11,0,0,0,1-1.19v-4.05a1.11,1.11,0,0,0-1-1.19h-8.38a1.11,1.11,0,0,0-1,1.19ZM448,273h-7.76v-3.43H448Z",
    transform: "translate(7.038 256.468)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M459.88,269.55v3.43l6.42.12.09-3.66Z",
    transform: "translate(7.221 256.469)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M396.18,450.31a3.134,3.134,0,0,1,.05-.46l.2-1.31c.19-1.19.47-2.88.82-5.06.74-4.42,1.8-10.76,3.1-18.59,2.62-15.72,6.23-37.39,10.22-61.32s7.46-45.66,9.94-61.38c1.22-7.84,2.21-14.2,2.9-18.62.35-2.18.61-3.88.8-5.06.1-.56.17-1,.22-1.31a4.4,4.4,0,0,1,.09-.45,3.69,3.69,0,0,1,0,.45,12.317,12.317,0,0,1-.17,1.33c-.16,1.18-.39,2.89-.7,5.07-.61,4.41-1.56,10.78-2.74,18.64-2.38,15.74-5.83,37.45-9.79,61.41s-7.64,45.63-10.36,61.3c-1.38,7.82-2.49,14.16-3.27,18.56-.39,2.17-.7,3.87-.92,5-.1.56-.19,1-.25,1.31A2.485,2.485,0,0,1,396.18,450.31Z",
    transform: "translate(6.714 257.105)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M453.37,451c-.15,0,.11-39,.56-87.06s.94-87.06,1.08-87.06-.11,39-.56,87.07S453.51,451,453.37,451Z",
    transform: "translate(7.129 257.108)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M463.37,451.68c0,.14-6.08.26-13.59.26s-13.58-.12-13.58-.26,6.08-.26,13.58-.26S463.37,451.53,463.37,451.68Z",
    transform: "translate(7.11 257.536)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M411.45,450.64a4.84,4.84,0,0,1-1.09.1l-3,.1-9.81.24c-3.83.08-7.3.11-9.81.09-1.26,0-2.27,0-3-.06a4.891,4.891,0,0,1-1.1-.1,4.421,4.421,0,0,1,1.09-.11l3-.1,9.8-.24c3.83-.08,7.3-.11,9.81-.08,1.26,0,2.27,0,3,.06A4.2,4.2,0,0,1,411.45,450.64Z",
    transform: "translate(6.584 257.531)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M488.72,212.66a24.849,24.849,0,0,1-.26-5,24.849,24.849,0,0,1,.26-5,24,24,0,0,1,.26,5,24,24,0,0,1-.26,5Z",
    transform: "translate(7.463 256.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M492.25,213.3a23.069,23.069,0,0,1-2.25-5.19,22.812,22.812,0,0,1-1.4-5.48,46.565,46.565,0,0,1,1.89,5.31,47.8,47.8,0,0,1,1.76,5.36Z",
    transform: "translate(7.484 256.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M104.11,377.89a21,21,0,0,1-3.76-8.29,6.62,6.62,0,0,1-.13-2.69,2.86,2.86,0,0,1,1.57-2.09,2.91,2.91,0,0,1,3,.71,7.67,7.67,0,0,1,1.69,2.71c2.32,5.41,3.26,11.5,4.5,17.26",
    transform: "translate(11.281 257.093)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(111.42 621.76)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M104.11,377.89a21,21,0,0,1-3.76-8.29,6.62,6.62,0,0,1-.13-2.69,2.86,2.86,0,0,1,1.57-2.09,2.91,2.91,0,0,1,3,.71,7.67,7.67,0,0,1,1.69,2.71c2.32,5.41,3.26,11.5,4.5,17.26",
    transform: "translate(-100.139 -364.667)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M107.5,382.34a21.8,21.8,0,0,0-17.62,5,10.36,10.36,0,0,0-3.17,4.25,5.24,5.24,0,0,0,.69,5.07c1.48,1.74,4.16,1.94,6.33,1.23,2.58-.84,4.69-2.7,6.72-4.5l9.64-8.61",
    transform: "translate(11.281 257.181)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(97.627 639.253)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M107.5,382.34a21.8,21.8,0,0,0-17.62,5,10.36,10.36,0,0,0-3.17,4.25,5.24,5.24,0,0,0,.69,5.07c1.48,1.74,4.16,1.94,6.33,1.23,2.58-.84,4.69-2.7,6.72-4.5l9.64-8.61",
    transform: "translate(-86.346 -382.072)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M107.79,357.34a28,28,0,0,1,11.44-19.41,14.06,14.06,0,0,1,6.54-2.78,7.08,7.08,0,0,1,6.39,2.52c1.73,2.37,1.32,5.74,0,8.38-2.08,4.3-6.11,7.43-10.52,9.25a45.15,45.15,0,0,1-14,2.8",
    transform: "translate(11.281 256.922)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M103.18,340.32c.8-4.88,3.37-9.31,6.36-13.24a15,15,0,0,1,3.27-3.38,6,6,0,0,1,4.47-1.08,5.4,5.4,0,0,1,4,4.68,8.09,8.09,0,0,1-2.06,6,16.53,16.53,0,0,1-5.22,3.87,37.539,37.539,0,0,1-10.56,3.58",
    transform: "translate(11.281 256.831)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M100.84,325.23c.06-6.31,2.62-13.47,7.41-17.57.85-.72,2-1.41,3-.86a2.67,2.67,0,0,1,1,1.47,12.64,12.64,0,0,1-11.44,17",
    transform: "translate(11.281 256.736)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M101.69,304.18c-2.82-4.51-3.27-12-.6-16.62a9.84,9.84,0,0,1,3.55-3.72,5.94,5.94,0,0,1,5-.49c2.75,1.09,3.95,4.56,3.3,7.45s-2.71,5.24-4.9,7.23-4.6,3.78-6.36,6.15",
    transform: "translate(11.281 256.602)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M115.51,382.44a17.87,17.87,0,0,1,2.18-13.06,20.58,20.58,0,0,1,10.72-8.67,11,11,0,0,1,5.29-.72,5.72,5.72,0,0,1,4.3,2.89c1.35,2.75-.47,6.15-3,7.83a36.56,36.56,0,0,1-8.28,4.23c-4.5,1.49-8.59,6.64-10.35,10.28",
    transform: "translate(11.281 257.08)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M120.64,403a28.46,28.46,0,0,1,4.59-16.35,15.55,15.55,0,0,1,6.64-6.39c2.85-1.24,6.53-1,8.68,1.29,2.75,2.9,2,7.86-.58,10.93s-6.35,4.75-10,6.42-6.47,3.59-8.66,6.93",
    transform: "translate(11.281 257.203)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M123.78,419.88c1.41-5.07,3-10.21,6.13-14.42s8.2-7.35,13.43-6.85c2.48.24,5,1.48,6,3.76,1.23,2.84-.36,6.12-2.4,8.44a22.73,22.73,0,0,1-10.81,6.84c-2.33.66-4.77,1-7,1.8a8.267,8.267,0,0,0-5.21,4.72",
    transform: "translate(11.281 257.315)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M124.21,426.89c-1.63-5.35-6.5-9-11.4-11.71-3.67-2-7.77-3.71-11.92-3.19s-8.18,4-7.91,8.18,4.66,7.16,8.87,7.76,8.5-.36,12.75-.27,8.29,1.3,10.06,5.17",
    transform: "translate(11.281 257.378)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M121.58,408.53a17,17,0,0,0-12-11,6.63,6.63,0,0,0-4.81.32,5.08,5.08,0,0,0-1.82,6.16,8.32,8.32,0,0,0,5.13,4.44,24.34,24.34,0,0,0,6.91,1,25,25,0,0,1,6.91.93",
    transform: "translate(11.281 257.261)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M107.5,286.88a2.639,2.639,0,0,1-.15.37c-.12.26-.29.61-.49,1.05l-.81,1.7c-.28.69-.61,1.48-1,2.37a64.569,64.569,0,0,0-2.18,6.69,68.9,68.9,0,0,0-1.72,9.14,89.52,89.52,0,0,0,.59,24.17,203.52,203.52,0,0,0,7.23,28.8c3.16,10.06,6.47,19.57,8.83,28.43a212.527,212.527,0,0,1,5,23.8c1,6.85,1.5,12.44,1.76,16.3.12,1.93.2,3.43.23,4.45v1.16a2.47,2.47,0,0,1,0,.4,2.589,2.589,0,0,1,0-.4l-.09-1.15c-.08-1.05-.18-2.54-.32-4.44-.32-3.86-.85-9.43-1.92-16.26a220.8,220.8,0,0,0-5.06-23.74c-2.38-8.82-5.71-18.32-8.87-28.4a200.159,200.159,0,0,1-7.2-28.88,88.74,88.74,0,0,1-.49-24.28,70.128,70.128,0,0,1,1.8-9.18,63.711,63.711,0,0,1,2.28-6.68c.38-.89.72-1.68,1-2.36s.62-1.22.85-1.69.41-.77.54-1a1.829,1.829,0,0,1,.19-.37Z",
    transform: "translate(11.281 257.074)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M66.2,361.45a3.091,3.091,0,0,1,.73,0c.48.05,1.18.09,2.08.23a59.929,59.929,0,0,1,7.55,1.51,67.21,67.21,0,0,1,22.82,10.93,64.12,64.12,0,0,1,10.3,9.47,58.542,58.542,0,0,1,6.6,9.33,61.051,61.051,0,0,1,3.4,6.91c.37.83.6,1.5.77,1.95a3.26,3.26,0,0,1,.23.69,4.05,4.05,0,0,1-.32-.65c-.21-.43-.47-1.09-.86-1.91a73.094,73.094,0,0,0-3.54-6.8,60.2,60.2,0,0,0-6.64-9.2,65.079,65.079,0,0,0-10.25-9.37,69.209,69.209,0,0,0-22.6-11A71.662,71.662,0,0,0,69,361.92c-.89-.17-1.59-.25-2.06-.33a6.544,6.544,0,0,1-.74-.14Z",
    transform: "translate(11.281 257.146)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M123.41,343.61a28.308,28.308,0,0,1-2.61,1.81,50.813,50.813,0,0,0-6,4.79,51.516,51.516,0,0,0-5.14,5.64,28,28,0,0,1-2,2.5,2.85,2.85,0,0,1,.39-.76c.28-.48.71-1.15,1.28-2a40,40,0,0,1,11.18-10.52c.84-.52,1.54-.91,2-1.16a3,3,0,0,1,.9-.3Z",
    transform: "translate(11.281 256.945)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M130,365.73c0,.09-1.31.54-3.25,1.69a21,21,0,0,0-9.89,13.91c-.46,2.21-.45,3.63-.54,3.63a3.489,3.489,0,0,1-.07-1,17.7,17.7,0,0,1,.24-2.7,19.88,19.88,0,0,1,10.08-14.16A18,18,0,0,1,129,366a3.4,3.4,0,0,1,1-.27Z",
    transform: "translate(11.281 257.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M132.58,386.54c0,.08-1,.74-2.6,2.07A25.39,25.39,0,0,0,121.82,402c-.46,2-.55,3.26-.65,3.25a3.14,3.14,0,0,1,0-.9,15.729,15.729,0,0,1,.3-2.43,23.34,23.34,0,0,1,2.94-7.54,22.93,22.93,0,0,1,5.35-6.05,17.069,17.069,0,0,1,2-1.39,3,3,0,0,1,.82-.4Z",
    transform: "translate(11.281 257.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M139.17,406.63c0,.09-1.15.58-2.92,1.61a29.26,29.26,0,0,0-11,11.33c-1,1.81-1.43,3-1.52,3a3.07,3.07,0,0,1,.24-.87,20.1,20.1,0,0,1,1-2.27,26.08,26.08,0,0,1,11.15-11.49,17.6,17.6,0,0,1,2.24-1,3,3,0,0,1,.81-.31Z",
    transform: "translate(11.281 257.328)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M107.85,401.52a6.73,6.73,0,0,1,2.51,0,15.38,15.38,0,0,1,10.24,6.06,7.32,7.32,0,0,1,1.24,2.19c-.08,0-.55-.79-1.52-2a17.29,17.29,0,0,0-10-5.92C108.81,401.62,107.85,401.61,107.85,401.52Z",
    transform: "translate(11.281 257.268)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M105.45,420a2.116,2.116,0,0,1,.75-.52,4.77,4.77,0,0,1,2.46-.34,10.749,10.749,0,0,1,3.49,1.14c1.23.59,2.58,1.25,3.95,2a27.291,27.291,0,0,1,6.5,4.81,15.175,15.175,0,0,1,1.56,1.91,3,3,0,0,1,.44.78c-.08.06-.78-1-2.26-2.43a31.409,31.409,0,0,0-6.49-4.62c-1.36-.76-2.7-1.43-3.91-2a11.309,11.309,0,0,0-3.33-1.21A5.32,5.32,0,0,0,105.45,420Z",
    transform: "translate(11.281 257.383)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M108.71,384a34.162,34.162,0,0,0-8.12,2.64,34,34,0,0,0-6.9,5,7.939,7.939,0,0,1,1.65-1.93,21.45,21.45,0,0,1,10.84-5.53A8.2,8.2,0,0,1,108.71,384Z",
    transform: "translate(11.281 257.162)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M108.54,383.5a6.93,6.93,0,0,1-1.1-1.72,30,30,0,0,1-1.93-4.51,29.64,29.64,0,0,1-1.18-4.76,6.51,6.51,0,0,1-.15-2c.16,0,.61,3,1.82,6.63S108.68,383.42,108.54,383.5Z",
    transform: "translate(11.281 257.101)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M117,327.52a17.861,17.861,0,0,1-2.19,1.68c-1.36,1-3.21,2.46-5.13,4.2s-3.53,3.44-4.67,4.7a17,17,0,0,1-1.89,2,12,12,0,0,1,1.61-2.25,44.75,44.75,0,0,1,9.87-9,12.572,12.572,0,0,1,2.4-1.33Z",
    transform: "translate(11.281 256.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M108.93,313.4c.12.11-2.09,2.35-4.37,5.45s-3.78,5.87-3.92,5.79a7.22,7.22,0,0,1,.84-1.89,33.4,33.4,0,0,1,2.67-4.2,34.68,34.68,0,0,1,3.23-3.8,7.06,7.06,0,0,1,1.55-1.35Z",
    transform: "translate(11.281 256.753)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M102.48,435.71H147.1v19.18a22.31,22.31,0,0,1-22.31,22.31h0a22.31,22.31,0,0,1-22.31-22.31V435.71Z",
    transform: "translate(11.281 257.604)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M147.05,449.19a12.53,12.53,0,0,1-1.73-.52c-1.11-.35-2.7-.9-4.71-1.39a22.071,22.071,0,0,0-7.17-.72,15.351,15.351,0,0,0-4.14.94c-1.39.51-2.79,1.17-4.27,1.77a16.889,16.889,0,0,1-4.52,1.27,14,14,0,0,1-4.37-.29c-2.72-.61-5-1.58-7-2.19a21,21,0,0,0-4.78-1h-1.33a1.529,1.529,0,0,1-.47,0,1.619,1.619,0,0,1,.47-.07,7.119,7.119,0,0,1,1.34-.06,19.159,19.159,0,0,1,4.88.89c2,.57,4.32,1.5,7,2.07a13.409,13.409,0,0,0,4.22.25,16.32,16.32,0,0,0,4.37-1.24c1.47-.59,2.88-1.25,4.3-1.77a16.158,16.158,0,0,1,4.27-.94,21.629,21.629,0,0,1,7.3.84c2,.55,3.6,1.15,4.69,1.56l1.24.5a2.465,2.465,0,0,1,.41.1Z",
    transform: "translate(11.281 257.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M147.05,446.51a12.539,12.539,0,0,1-1.73-.52c-1.11-.36-2.7-.9-4.71-1.4a22.351,22.351,0,0,0-7.17-.72,15.76,15.76,0,0,0-4.14.95c-1.39.51-2.79,1.17-4.27,1.77a17.269,17.269,0,0,1-4.52,1.27,14,14,0,0,1-4.37-.3c-2.72-.61-5-1.57-7-2.19a21.479,21.479,0,0,0-4.78-1,9.3,9.3,0,0,0-1.33,0h-.47a1.391,1.391,0,0,1,.47-.08,7.293,7.293,0,0,1,1.34-.05,18.628,18.628,0,0,1,4.88.88c2,.58,4.32,1.51,7,2.07a13.409,13.409,0,0,0,4.22.26,17.091,17.091,0,0,0,4.37-1.24c1.47-.6,2.88-1.26,4.3-1.77a15.8,15.8,0,0,1,4.27-.95,22.151,22.151,0,0,1,7.3.84,46.537,46.537,0,0,1,4.69,1.57l1.24.5C146.91,446.42,147.06,446.49,147.05,446.51Z",
    transform: "translate(11.281 257.504)",
    fill: "#263238"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageImage);
export default __webpack_public_path__ + "static/media/HomePageImage.468a8c3723175a8f73f0e40814dad520.svg";
export { ForwardRef as ReactComponent };